import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChannelsandoperationsService } from '../../../../services/channelsandoperations.service';
import {HelpersService} from 'src/app/services/helpers.service';

@Component({
  selector: 'app-editar-canal',
  templateUrl: './editar-canal.component.html',
  styleUrls: ['./editar-canal.component.scss'],
})
export class EditarCanalComponent implements OnInit {
  channelCreateForm = this.fb.group({
    nombre: [
      '',
      [
        Validators.required,
        Validators.maxLength(30),
      ],
    ],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')],
  });
  constructor(
    public dialogRef: MatDialogRef<EditarCanalComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public canalService: ChannelsandoperationsService,
    public helper: HelpersService
  ) {}

  ngOnInit(): void {
    this.channelCreateForm.controls.nombre.setValue(this.data.nombre);
  }

  onSubmit() {
    this.channelCreateForm.controls.id_usuarios_creador.setValue(
      sessionStorage.getItem('id_usuario')
    );
    this.canalService
      .updateChannel(this.data.id_canales, this.channelCreateForm.value)
      .subscribe((data) => {
        console.log("Respuesta",data)
        this.helper.snackbar(`Canal editado con éxito`)
        this.dialogRef.close()
      },err=>{
        console.log(err.error.payload)
        this.helper.snackbar(err.error.payload)
      });
  }
}
